module.exports = __webpack_public_path__ + "img/taili7.1cd8da89.jpg";